export enum SCHEDULE_TABS {
  MINHA_AGENDA = 1,
  GERAL,
  E_AGENDA,
}

export const TITLE = ['', 'Minha Agenda', 'Geral', 'E-Agendas']

export const SUBTITLE = [
  '',
  'Visualize os eventos de sua agenda',
  'Visualize todos os eventos legislativos e executivos',
  'Visualize os eventos executivos',
]
